export default {
    "messages": {
        "no-data": "Currently no data available",
        "latina": {
            "player": {
                "share": "Partilhar",
                "share-message": "Estou a ouvir {song}-{artist} na Rádio Latina",
                "no-track-info": "Sem informação da música",
                "no-artist": "Sem artista",
                "last-tracks": {
                    "title": "Últimas Músicas"
                }
            }
        },
        "service": {
            "traffic":{
                "alert": {
                    "title": "Traffic information",
                    "none": "No current traffic alerts"
                },
                "trafficcamera": {
                    "title": "Traffic Cameras"
                },
                "parking": {
                    "title": "Parking",
                    "defaultDistrict": "Centre",
                    "column": {
                        "carParks": "Car parks",
                        "capacity": "Capacity",
                        "occupied": "Occupied",
                        "free": "Free",
                        "trend": "Trend"
                    },
                    "closed": "closed"
                },
                "no-data": "no data"
            },
            "sport-results": {
                "sport-name": {
                    "footballNational": "National football",
                    "footballInternational": "International football",
                    "basketball": "Basketball",
                    "handball": "Handball",
                    "volleyball": "Volleyball",
                    "tableTennis": "Table Tennis"
                },
                "title": {
                    "prefix": "Results for match day",
                    "day": "",
                    "suffix": "",
                    "mobile-prefix": "Results",
                    "mobile-suffix": "matchday"
                },
                "ranking": {
                    "title": "Table after the current match day",
                    "mobile-title": "Table (current match day)",
                    "position": "Pos.",
                    "team": "Team",
                    "played": "Pl.",
                    "won": "W.",
                    "draw":"D.",
                    "lost": "L.",
                    "difference": "GD",
                    "points": "Pts"
                }
            },
            "commons": {
                "luxembourgCitySouth": "Luxembourg City (South)",
                "germanyBorder": "Germany",
                "franceBorder": "France",
                "luxembourgCityHollerich": "Luxembourg Hollerich",
                "eschSurAlzette": "Esch-sur-Alzette",
                "belgiumBorder": "Belgium",
                "grunewald": "Grunewald",
                "colmarBerg": "Colmar-Berg",
                "sarrebruck": "Sarrebruck",
                "longwy": "Longwy",
                "no-data": "Currently no data available"
            },
            "events": {
                "countries": {
                    "lu": "Luxembourg",
                    "de": "Germany",
                    "fr": "France",
                    "be": "Belgium",
                    "none": ""
                },
                "upcoming": "Upcoming",
                "permanents": "Lasting events",
                "timeFromFormat": "from",
                "timeToFormat": "to",
                "dateStartFormat": "[From ]MMM Do YYYY",
                "dateStartingFromFormat": "from",
                "dateEndFormat": " [to] MMM Do YYYY",
                "allEvents": "All events",
                "no-events": "There are no events for the next 30 days",
                "categories": {
                    "all": "All",
                    "concerts": "Concerts",
                    "nightlife": "Nightlife",
                    "dance": "Dance",
                    "opera_theatre": "Opera & Theatre",
                    "sport": "Sport",
                    "spectacle": "Shows",
                    "festivity_festival": "Festivities & Festivals",
                    "conference_seminar": "Conferences & Seminars",
                    "exhibition": "Exhibitions",
                    "family_kids": "Family & kids",
                    "other": "Other"
                },
                "event-details": {
                    "show-more-dates": "Show more dates",
                    "show-map": "Display map",
                    "free": "Free",
                    "fallback-description": "Description is not available in your language",
                    "no-description": "Description is not available",
                    "canceled": "canceled",
                    "monday": "Monday",
                    "tuesday": "Tuesday",
                    "wednesday": "Wednesday",
                    "thursday": "Thursday",
                    "friday": "Friday",
                    "saturday": "Saturday",
                    "sunday": "Sunday",
                    "closed": "closed"
                }
            }
        },
        "commons": {
            "delete": "Delete",
            "show-more": "Show more"
        },
        "share-buttons": {
            "copy-to-clipboard-message": "The link has been copied to your clipboard."
        },
        "homepage": {
            "new-articles": "New articles available"
        },
        "notifications-page": {
            "subscription": {
                "success": {
                    "subscribe": "Successfully subscribed!",
                    "unsubscribe": "Successfully unsubscribed!"
                },
                "fail": "Sorry, something went wrong, we couldn't register you. Please, try again."
            },
            "permission": {
                "blocked": "You can't subscribe to luxtimes.lu notifications as you have blocked them. Please allow them in your browser to be able to receive them"
            },
            "unsupported-browser": "Sorry, your browser doesn't support notifications"
        },
        "services": {
            "announcements": {
                "births": "[not used] Births",
                "weddings": "[not used] Weddings",
                "obituaries": "[not used] Obituaries"
            }
        }
    }
};



// WEBPACK FOOTER //
// ./js/i18n/TranslationEnglish.js